/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.1-v202611051432-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqConditionMonitorsApiClass {
 
   constructor() {}

  /**
   * @summary Archive a condition monitor
   * @param {string} id - ID of the condition monitor to archive.
  */
  public archiveConditionMonitor(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/condition-monitors/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new condition monitor
  */
  public createConditionMonitor(
    body: models.ConditionMonitorInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors`;
    const urlTemplate = `${baseUrl}/condition-monitors`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ConditionMonitorOutputV1>;
  }

  /**
   * @summary Get a condition monitor
   * @param {string} id - The Seeq ID for the condition monitor
   * @param {boolean} [includeConditions=true] - Whether to include the conditionIds and suppressedConditions lists of each Condition Monitor in the response. Both lists are unbounded, so pass false for monitors with many conditions and page through GET /condition-monitors/{id}/conditions instead. conditionCount is returned either way.
  */
  public getConditionMonitor(
    {
      id,
      includeConditions
    } : {
      id: string,
      includeConditions?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/condition-monitors/{id}`;

    const queryParams = {
      ['includeConditions']: includeConditions
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ConditionMonitorOutputV1>;
  }

  /**
   * @summary Get a list of metadata associated with condition monitors, including various properties that define their current state and behavior
   * @param {Array<string>} [creatorIds] - Filter items to only those created by the specified user IDs
   * @param {string} [nameSearch] - Filter the items to those whose name match any part of the specified string
   * @param {string} [workbookSearch] - Filter the items to those whose condition are scoped to workbooks that match any part of the specified string
   * @param {Array<string>} [conditionIds] - Filter items to only those that are monitoring one of the specified conditions as specified by the list of IDs
   * @param {boolean} [enabledFilter] - Filter items by their enabled status
   * @param {string} [workbookTypeFilter] - Filter items by the type of workbook they are scoped to
   * @param {number} [offset=0] - The pagination offset, the number of items that will be skipped.
   * @param {number} [limit=40] - The pagination limit, the total number of items that will be returned in this page of results
   * @param {string} [sortBy=Name] - Order the items by name, workbook, createdAt, conditionCount, averageRunTime, or totalRunTime
   * @param {boolean} [sortAsc=true] - Sorts the sort field in ascending order when true and descending when false
   * @param {boolean} [includeConditionIds=true] - When false, omit the list of monitored condition IDs from each result. The conditionCount field is always returned.
   * @param {boolean} [includeWorkbooks=true] - When false, omit the map of condition-scoped workbooks from each result
  */
  public getConditionMonitorMetadataList(
    {
      creatorIds,
      nameSearch,
      workbookSearch,
      conditionIds,
      enabledFilter,
      workbookTypeFilter,
      offset,
      limit,
      sortBy,
      sortAsc,
      includeConditionIds,
      includeWorkbooks
    } : {
      creatorIds?: Array<string>,
      nameSearch?: string,
      workbookSearch?: string,
      conditionIds?: Array<string>,
      enabledFilter?: boolean,
      workbookTypeFilter?: GetConditionMonitorMetadataListWorkbookTypeFilterEnum,
      offset?: number,
      limit?: number,
      sortBy?: GetConditionMonitorMetadataListSortByEnum,
      sortAsc?: boolean,
      includeConditionIds?: boolean,
      includeWorkbooks?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/metadata`;
    const urlTemplate = `${baseUrl}/condition-monitors/metadata`;

    const queryParams = {
      ['creatorIds']: creatorIds,      ['nameSearch']: nameSearch,      ['workbookSearch']: workbookSearch,      ['conditionIds']: conditionIds,      ['enabledFilter']: enabledFilter,      ['workbookTypeFilter']: workbookTypeFilter,      ['offset']: offset,      ['limit']: limit,      ['sortBy']: sortBy,      ['sortAsc']: sortAsc,      ['includeConditionIds']: includeConditionIds,      ['includeWorkbooks']: includeWorkbooks
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ConditionMonitorMetadataOutputListV1>;
  }

  /**
   * @summary Get suppressed conditions for a condition monitor. This method is deprecated.
   * @param {string} id - The Seeq ID for the condition monitor
   * @deprecated Use GET /condition-monitors/{id}/conditions with suppressedFilter set to true, which is paginated.
  */
  public getConditionMonitorSuppressions(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(id))}/suppressions`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/condition-monitors/{id}/suppressions`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<Array<models.SuppressedConditionOutputV1>>;
  }

  /**
   * @summary Get a list of condition monitors
   * @param {Array<string>} [executorIds] - Filter condition monitors to only those created by the specified user IDs
   * @param {string} [nameSearch] - Filter the condition monitors to those whose name match any part of the specified string
   * @param {Array<string>} [conditionIds] - Filter condition monitors to only those that are monitoring one of the specified conditions as specified by the list of IDs
   * @param {boolean} [enabledFilter] - Filter condition monitors by their enabled status
   * @param {number} [offset=0] - Whether to filter condition monitors to only users who are enabled.
   * @param {number} [limit=40] - The pagination limit, the total number of condition monitor that will be returned in this page of results
   * @param {string} [sortField=Name] - Orders the condition monitors by either name, createdAt or workbook
   * @param {boolean} [sortAsc=true] - Sorts the sort field in ascending order when true and descending when false
   * @param {boolean} [includeConditions=true] - Whether to include the conditionIds and suppressedConditions lists of each Condition Monitor in the response. Both lists are unbounded, so pass false for monitors with many conditions and page through GET /condition-monitors/{id}/conditions instead. conditionCount is returned either way.
  */
  public getConditionMonitors(
    {
      executorIds,
      nameSearch,
      conditionIds,
      enabledFilter,
      offset,
      limit,
      sortField,
      sortAsc,
      includeConditions
    } : {
      executorIds?: Array<string>,
      nameSearch?: string,
      conditionIds?: Array<string>,
      enabledFilter?: boolean,
      offset?: number,
      limit?: number,
      sortField?: GetConditionMonitorsSortFieldEnum,
      sortAsc?: boolean,
      includeConditions?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors`;
    const urlTemplate = `${baseUrl}/condition-monitors`;

    const queryParams = {
      ['executorIds']: executorIds,      ['nameSearch']: nameSearch,      ['conditionIds']: conditionIds,      ['enabledFilter']: enabledFilter,      ['offset']: offset,      ['limit']: limit,      ['sortField']: sortField,      ['sortAsc']: sortAsc,      ['includeConditions']: includeConditions
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetConditionMonitorItemsOutputV1>;
  }

  /**
   * @summary Get a paginated list of monitored conditions for a condition monitor
   * @param {string} conditionMonitorId
   * @param {boolean} [errorFilter] - Filter to only conditions with at least one error (true) or no errors (false)
   * @param {boolean} [suppressedFilter] - Filter to only suppressed conditions (true) or only non-suppressed (false)
   * @param {number} [offset=0] - The pagination offset, the index of the first item returned in this page
   * @param {number} [limit=40] - The pagination limit, the maximum number of items returned in this page (at most 1000)
   * @param {string} [orderBy=ConditionId] - Field to order by: ConditionId, ErrorCount, or LastErrorTime
   * @param {boolean} [sortAsc=true] - Sort ascending when true, descending when false
   * @param {boolean} [includeAsset=false] - Whether to include the asset name(s) in the response. Defaults to false.
   * @param {string} [nameSearch] - Filter monitored conditions to those whose name contains the specified string
  */
  public getMonitoredConditions(
    {
      conditionMonitorId,
      errorFilter,
      suppressedFilter,
      offset,
      limit,
      orderBy,
      sortAsc,
      includeAsset,
      nameSearch
    } : {
      conditionMonitorId: string,
      errorFilter?: boolean,
      suppressedFilter?: boolean,
      offset?: number,
      limit?: number,
      orderBy?: GetMonitoredConditionsOrderByEnum,
      sortAsc?: boolean,
      includeAsset?: boolean,
      nameSearch?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (conditionMonitorId === null || conditionMonitorId === undefined) {
      throw new Error("'conditionMonitorId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(conditionMonitorId))}/conditions`
      .replace('{conditionMonitorId}', encodeURIComponent(String(conditionMonitorId)));
    const urlTemplate = `${baseUrl}/condition-monitors/{conditionMonitorId}/conditions`;

    const queryParams = {
      ['errorFilter']: errorFilter,      ['suppressedFilter']: suppressedFilter,      ['offset']: offset,      ['limit']: limit,      ['orderBy']: orderBy,      ['sortAsc']: sortAsc,      ['includeAsset']: includeAsset,      ['nameSearch']: nameSearch
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.MonitoredConditionOutputListV1>;
  }

  /**
   * @summary Triggers an immediate execution of the condition monitor job if it is not currently running. If the job is already, run after current job completes.
   * @param {string} id - The Seeq ID for the condition monitor
  */
  public runConditionMonitorJob(
    body: models.RunConditionMonitorJobInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(id))}/run`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/condition-monitors/{id}/run`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Suppress one or more conditions in a condition monitor
   * @param {string} id - The Seeq ID for the condition monitor
  */
  public suppressConditions(
    body: Array<models.SuppressConditionInputV1>,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(id))}/suppress`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/condition-monitors/{id}/suppress`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Unsuppress one or more conditions in a condition monitor
   * @param {string} id - The Seeq ID for the condition monitor
  */
  public unsuppressConditions(
    body: Array<string>,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(id))}/unsuppress`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/condition-monitors/{id}/unsuppress`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Update a condition monitor
   * @param {string} id - The Seeq ID for the condition monitor
   * @param {boolean} [includeConditions=true] - Whether to include the conditionIds and suppressedConditions lists of each Condition Monitor in the response. Both lists are unbounded, so pass false for monitors with many conditions and page through GET /condition-monitors/{id}/conditions instead. conditionCount is returned either way.
  */
  public updateConditionMonitor(
    body: models.ConditionMonitorInputV1,
    {
      id,
      includeConditions
    } : {
      id: string,
      includeConditions?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/condition-monitors/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/condition-monitors/{id}`;

    const queryParams = {
      ['includeConditions']: includeConditions
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ConditionMonitorOutputV1>;
  }

}

export const GetConditionMonitorMetadataListWorkbookTypeFilterEnum = {
    Analysis: 'Analysis',
    Vantage: 'Vantage'
} as const;

export type GetConditionMonitorMetadataListWorkbookTypeFilterEnum = typeof GetConditionMonitorMetadataListWorkbookTypeFilterEnum[keyof typeof GetConditionMonitorMetadataListWorkbookTypeFilterEnum];
export const GetConditionMonitorMetadataListSortByEnum = {
    Name: 'Name',
    CreatedAt: 'CreatedAt',
    Workbook: 'Workbook',
    ConditionCount: 'ConditionCount',
    AverageRunTime: 'AverageRunTime',
    TotalRunTime: 'TotalRunTime'
} as const;

export type GetConditionMonitorMetadataListSortByEnum = typeof GetConditionMonitorMetadataListSortByEnum[keyof typeof GetConditionMonitorMetadataListSortByEnum];
export const GetConditionMonitorsSortFieldEnum = {
    Name: 'Name',
    CreatedAt: 'CreatedAt'
} as const;

export type GetConditionMonitorsSortFieldEnum = typeof GetConditionMonitorsSortFieldEnum[keyof typeof GetConditionMonitorsSortFieldEnum];
export const GetMonitoredConditionsOrderByEnum = {
    ConditionId: 'ConditionId',
    ErrorCount: 'ErrorCount',
    LastErrorTime: 'LastErrorTime'
} as const;

export type GetMonitoredConditionsOrderByEnum = typeof GetMonitoredConditionsOrderByEnum[keyof typeof GetMonitoredConditionsOrderByEnum];

export const sqConditionMonitorsApi = new sqConditionMonitorsApiClass();

export type sqConditionMonitorsApiEndpoints = {
  'archiveConditionMonitor': {
    method: 'delete';
    path: '/condition-monitors/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createConditionMonitor': {
    method: 'post';
    path: '/condition-monitors';
    response: models.ConditionMonitorOutputV1;
  };
  'getConditionMonitor': {
    method: 'get';
    path: '/condition-monitors/${encodeURIComponent(String(id))}';
    response: models.ConditionMonitorOutputV1;
  };
  'getConditionMonitorMetadataList': {
    method: 'get';
    path: '/condition-monitors/metadata';
    response: models.ConditionMonitorMetadataOutputListV1;
  };
  'getConditionMonitorSuppressions': {
    method: 'get';
    path: '/condition-monitors/${encodeURIComponent(String(id))}/suppressions';
    response: Array<models.SuppressedConditionOutputV1>;
  };
  'getConditionMonitors': {
    method: 'get';
    path: '/condition-monitors';
    response: models.GetConditionMonitorItemsOutputV1;
  };
  'getMonitoredConditions': {
    method: 'get';
    path: '/condition-monitors/${encodeURIComponent(String(conditionMonitorId))}/conditions';
    response: models.MonitoredConditionOutputListV1;
  };
  'runConditionMonitorJob': {
    method: 'post';
    path: '/condition-monitors/${encodeURIComponent(String(id))}/run';
    response: models.StatusMessageBase;
  };
  'suppressConditions': {
    method: 'post';
    path: '/condition-monitors/${encodeURIComponent(String(id))}/suppress';
    response: {};
  };
  'unsuppressConditions': {
    method: 'post';
    path: '/condition-monitors/${encodeURIComponent(String(id))}/unsuppress';
    response: {};
  };
  'updateConditionMonitor': {
    method: 'post';
    path: '/condition-monitors/${encodeURIComponent(String(id))}';
    response: models.ConditionMonitorOutputV1;
  };
};

type ApiArchiveConditionMonitorResponse = models.ArchiveOutputV1;
type ApiarchiveConditionMonitorMutationParams = Parameters<typeof sqConditionMonitorsApi.archiveConditionMonitor> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionMonitorsApi.archiveConditionMonitor>;

export function useApiArchiveConditionMonitorMutation(
  options?: Omit<UseMutationOptions<ApiArchiveConditionMonitorResponse, AxiosError<SeeqErrorData>,
    ApiarchiveConditionMonitorMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveConditionMonitorResponse, AxiosError<SeeqErrorData>,
  ApiarchiveConditionMonitorMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveConditionMonitorMutationParams) =>
      sqConditionMonitorsApi.archiveConditionMonitor(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateConditionMonitorResponse = models.ConditionMonitorOutputV1;
type ApicreateConditionMonitorMutationParams = Parameters<typeof sqConditionMonitorsApi.createConditionMonitor> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionMonitorsApi.createConditionMonitor>;
type ApicreateConditionMonitorMutationVariables = models.ConditionMonitorInputV1;

export function useApiCreateConditionMonitorMutation(
  options?: Omit<UseMutationOptions<ApiCreateConditionMonitorResponse, AxiosError<SeeqErrorData>,
    ApicreateConditionMonitorMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateConditionMonitorResponse, AxiosError<SeeqErrorData>,
  ApicreateConditionMonitorMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateConditionMonitorMutationVariables) =>
      sqConditionMonitorsApi.createConditionMonitor(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetConditionMonitorResponse = models.ConditionMonitorOutputV1;
export function GetConditionMonitorQueryKey(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitor>[0],
) {
  return ['sqConditionMonitorsApi', 'getConditionMonitor', params] as const;
}

export function useApiGetConditionMonitorQuery(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitor>[0],
  options?: Omit<UseQueryOptions<ApiGetConditionMonitorResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetConditionMonitorResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetConditionMonitorQueryKey(params),
    queryFn: () =>
      sqConditionMonitorsApi.getConditionMonitor(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConditionMonitorMetadataListResponse = models.ConditionMonitorMetadataOutputListV1;
export function GetConditionMonitorMetadataListQueryKey(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitorMetadataList>[0],
) {
  return ['sqConditionMonitorsApi', 'getConditionMonitorMetadataList', params] as const;
}

export function useApiGetConditionMonitorMetadataListQuery(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitorMetadataList>[0],
  options?: Omit<UseQueryOptions<ApiGetConditionMonitorMetadataListResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetConditionMonitorMetadataListResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetConditionMonitorMetadataListQueryKey(params),
    queryFn: () =>
      sqConditionMonitorsApi.getConditionMonitorMetadataList(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConditionMonitorSuppressionsResponse = Array<models.SuppressedConditionOutputV1>;
export function GetConditionMonitorSuppressionsQueryKey(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitorSuppressions>[0],
) {
  return ['sqConditionMonitorsApi', 'getConditionMonitorSuppressions', params] as const;
}

export function useApiGetConditionMonitorSuppressionsQuery(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitorSuppressions>[0],
  options?: Omit<UseQueryOptions<ApiGetConditionMonitorSuppressionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetConditionMonitorSuppressionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetConditionMonitorSuppressionsQueryKey(params),
    queryFn: () =>
      sqConditionMonitorsApi.getConditionMonitorSuppressions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetConditionMonitorsResponse = models.GetConditionMonitorItemsOutputV1;
export function GetConditionMonitorsQueryKey(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitors>[0],
) {
  return ['sqConditionMonitorsApi', 'getConditionMonitors', params] as const;
}

export function useApiGetConditionMonitorsQuery(
  params: Parameters<typeof sqConditionMonitorsApi.getConditionMonitors>[0],
  options?: Omit<UseQueryOptions<ApiGetConditionMonitorsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetConditionMonitorsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetConditionMonitorsQueryKey(params),
    queryFn: () =>
      sqConditionMonitorsApi.getConditionMonitors(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetMonitoredConditionsResponse = models.MonitoredConditionOutputListV1;
export function GetMonitoredConditionsQueryKey(
  params: Parameters<typeof sqConditionMonitorsApi.getMonitoredConditions>[0],
) {
  return ['sqConditionMonitorsApi', 'getMonitoredConditions', params] as const;
}

export function useApiGetMonitoredConditionsQuery(
  params: Parameters<typeof sqConditionMonitorsApi.getMonitoredConditions>[0],
  options?: Omit<UseQueryOptions<ApiGetMonitoredConditionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetMonitoredConditionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetMonitoredConditionsQueryKey(params),
    queryFn: () =>
      sqConditionMonitorsApi.getMonitoredConditions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiRunConditionMonitorJobResponse = models.StatusMessageBase;
type ApirunConditionMonitorJobMutationParams = Parameters<typeof sqConditionMonitorsApi.runConditionMonitorJob> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionMonitorsApi.runConditionMonitorJob>;

export function useApiRunConditionMonitorJobMutation(
  options?: Omit<UseMutationOptions<ApiRunConditionMonitorJobResponse, AxiosError<SeeqErrorData>,
    ApirunConditionMonitorJobMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiRunConditionMonitorJobResponse, AxiosError<SeeqErrorData>,
  ApirunConditionMonitorJobMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApirunConditionMonitorJobMutationParams) =>
      sqConditionMonitorsApi.runConditionMonitorJob(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSuppressConditionsResponse = {};
type ApisuppressConditionsMutationParams = Parameters<typeof sqConditionMonitorsApi.suppressConditions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionMonitorsApi.suppressConditions>;

export function useApiSuppressConditionsMutation(
  options?: Omit<UseMutationOptions<ApiSuppressConditionsResponse, AxiosError<SeeqErrorData>,
    ApisuppressConditionsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSuppressConditionsResponse, AxiosError<SeeqErrorData>,
  ApisuppressConditionsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApisuppressConditionsMutationParams) =>
      sqConditionMonitorsApi.suppressConditions(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUnsuppressConditionsResponse = {};
type ApiunsuppressConditionsMutationParams = Parameters<typeof sqConditionMonitorsApi.unsuppressConditions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionMonitorsApi.unsuppressConditions>;

export function useApiUnsuppressConditionsMutation(
  options?: Omit<UseMutationOptions<ApiUnsuppressConditionsResponse, AxiosError<SeeqErrorData>,
    ApiunsuppressConditionsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUnsuppressConditionsResponse, AxiosError<SeeqErrorData>,
  ApiunsuppressConditionsMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiunsuppressConditionsMutationParams) =>
      sqConditionMonitorsApi.unsuppressConditions(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateConditionMonitorResponse = models.ConditionMonitorOutputV1;
type ApiupdateConditionMonitorMutationParams = Parameters<typeof sqConditionMonitorsApi.updateConditionMonitor> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqConditionMonitorsApi.updateConditionMonitor>;

export function useApiUpdateConditionMonitorMutation(
  options?: Omit<UseMutationOptions<ApiUpdateConditionMonitorResponse, AxiosError<SeeqErrorData>,
    ApiupdateConditionMonitorMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateConditionMonitorResponse, AxiosError<SeeqErrorData>,
  ApiupdateConditionMonitorMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateConditionMonitorMutationParams) =>
      sqConditionMonitorsApi.updateConditionMonitor(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
